import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'agentCodeFilter'
})
export class AgentCodeFilterPipe implements PipeTransform {

  transform(value: any[], agent_code: string): any[] {
    if (agent_code !== '') {
      return value.filter(
        item => item.agent_code.toLowerCase().indexOf(agent_code.toLowerCase()) > -1)
      } else {
      return value;
    }
  }
}

